import axios from "axios";

const host = process.env.VUE_APP_API_SERVER;
const url = host + "/api/v1/usuarios-disponibles";

function obtenerHeaders(session) {
  if (!session || !session.exists()) {
    throw new Error("La sesión no está disponible");
  }

  const jwt = session.get("jwt");

  if (!jwt) {
    throw new Error("El token de sesión no está disponible");
  }

  return {
    Authorization: "Bearer " + jwt,
  };
}

export async function consultarUsuariosDisponibles(
  session,
  opciones = {}
) {
  const response = await axios.get(url, {
    headers: obtenerHeaders(session),
    params: {
      username: opciones.username || "",
      pagina: opciones.pagina || 1,
      limite: opciones.limite || 50,
    },
  });

  const resultado = response.data;

  if (resultado.correcto === false) {
    throw new Error(resultado.mensaje || "No se pudo consultar");
  }

  return resultado;
}

export async function exportarUsuariosDisponibles(
  session,
  username = ""
) {
  const response = await axios.get(url + "/exportar", {
    headers: obtenerHeaders(session),
    params: { username },
    responseType: "blob",
  });

  if (response.data.type === "application/json") {
    const texto = await response.data.text();
    const resultado = JSON.parse(texto);

    if (resultado.correcto === false) {
      throw new Error(resultado.mensaje || "No se pudo exportar");
    }
  }

  const archivo = new Blob(
    [response.data],
    {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }
  );

  const enlace = document.createElement("a");
  const archivoUrl = URL.createObjectURL(archivo);

  enlace.href = archivoUrl;
  enlace.download = "usuarios_disponibles.xlsx";

  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();

  URL.revokeObjectURL(archivoUrl);
}
